import { TitleFormSectionSubTitle } from '@dataplace.ai/ui-components/atoms/TileComponents/TileFormSectionSubTitle/TileFormSectionSubTitle'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div(({ theme: { palette } }) => `
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1.5rem;
  background-color: ${palette.light.white};
`)

export const Section = styled.div(({
  theme: {
    palette, corners,
  },
}) => css`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: ${palette.light.white};
  border: 1px solid ${palette.light.darkest};
  border-radius: ${corners.default.borderRadius};
  color: ${palette.black};
  margin-bottom: 30px;
`)

export const SectionMainText = styled.p(({ theme: { typography } }) => `
  font-size: ${typography.main.pt_15_semibold.fontSize};
  font-weight: ${typography.main.pt_15_semibold.fontWeight};
  line-height: ${typography.main.pt_15_semibold.lineHeight};
  margin-bottom: 15px;
`)

export const SectionTitle = styled.h4(({ theme: { typography } }) => `
  font-size: ${typography.main.pt_15_medium_upper.fontSize};
  font-weight: ${typography.main.pt_15_medium_upper.fontWeight};
  line-height: ${typography.main.pt_15_medium_upper.lineHeight};
  letter-spacing: ${typography.main.pt_15_medium_upper.letterSpacing};
  text-transform: ${typography.main.pt_15_medium_upper.textTransform};
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`)

export const CompetitorsNumber = styled.span(({ theme: { typography } }) => `
  font-size: ${typography.big.pt_28_semibold.fontSize};
  font-weight: ${typography.big.pt_28_semibold.fontWeight};
  line-height: ${typography.big.pt_28_semibold.lineHeight};
  font-family: 'Inter',sans-serif;
  display: inline;
  margin-left: 0.25rem;
`)

export const MapWrapper = styled.div`
  margin: 1rem 0;
  width: 100%;
  height: 300px;

  @media print {
    margin: 0;
  }
`

export const PopupContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

// Have to use raw values instead of theme's typography, because it's used inside of renderToStaticMarkup()
// and it errors out if typography is used
export const StyledPopupParagraph = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 !important;
`

export const StyledTitleFormSectionSubTitle = styled(TitleFormSectionSubTitle)(({ theme: { palette } }) => css`
  border-top: 1px solid ${palette.light.darker};
  padding-top: 2rem;
  margin-bottom: 0;
`)
